
export const simulation = {
  'simulation.title': 'Simulate a Scenario',
  'simulation.tabs.form': 'Form Input',
  'simulation.tabs.upload': 'Upload Document',
  'simulation.tabs.chat': 'Ask AgriBot',
  'simulation.description': 'Explore potential subsidy matches without creating a farm',
  'simulation.form.heading': 'Hypothetical Farm Details',
  'simulation.form.region': 'Region',
  'simulation.form.country': 'Country',
  'simulation.form.size': 'Farm Size (hectares)',
  'simulation.form.irrigation': 'Irrigation Method',
  'simulation.form.certifications': 'Certifications',
  'simulation.form.carbonScore': 'Carbon Score',
  'simulation.form.goals': 'Sustainability Goals',
  'simulation.form.submit': 'Find Matching Subsidies',
  'simulation.upload.heading': 'Upload Farm Document',
  'simulation.upload.description': 'Upload a PDF or DOCX file to extract farm details',
  'simulation.upload.button': 'Upload Document',
  'simulation.upload.dragDrop': 'Drag and drop your file here or click to browse',
  'simulation.upload.analyzing': 'Analyzing document...',
  'simulation.upload.complete': 'OCR Complete',
  'simulation.upload.extractedInfo': 'Extracted Information',
  'simulation.chat.heading': 'Describe Your Project',
  'simulation.chat.placeholder': 'Describe your future agricultural project...',
  'simulation.chat.hint': 'For example: "A dairy farm switching to organic in southwest Romania."',
  'simulation.chat.send': 'Send',
  'simulation.results.heading': 'Simulation Results',
  'simulation.results.matchCount': 'Potential subsidy matches',
  'simulation.results.confidence': 'Match Confidence',
  'simulation.results.saveFarm': 'Save As Hypothetical Scenario',
  'simulation.results.downloadReport': 'Download Simulation Report (PDF)',
  'simulation.results.attachToFarm': 'Link to New Farm',
} as const;
